<template>
  <div>
    <div class="product-container">
      <el-row :gutter="16">
        <el-col :span="12">
          <baidu-map
            :center="center"
            :zoom="zoom"
            class="map"
            :scroll-wheel-zoom="true"
            @ready="handler"
          >
            <bm-marker
              :position="{ lng: 108.950109, lat: 34.332414 }"
              :dragging="true"
              animation="BMAP_ANIMATION_BOUNCE"
            >
              <!-- <bm-label
          content="我爱北京天安门"
          :label-style="{ color: 'red', fontSize: '24px' }"
          :offset="{ width: -35, height: 30 }"
        /> -->
            </bm-marker>
          </baidu-map>
        </el-col>
        <el-col :span="8">
          <h2
            style="color:#4e56c5;text-align:center;margin-left:14px;margin-top:80px"
          >
            星年物联网期待与您的合作
          </h2>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      center: { lng: 108.950109, lat: 34.332414 },
      zoom: 3
    }
  },
  methods: {
    handler({ BMap, map }) {
      console.log(BMap, map)
      this.center.lng = 108.950109
      this.center.lat = 34.332414
      this.zoom = 18
    }
  }
}
</script>
<style lang="scss" scope>
.map {
  width: 450px;
  height: 300px;
}
</style>
